/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio, variant_title) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = variant_title + ' | ' + formatPrice(price);

    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  function getCustomVariantTitle(price, title) {
    const capsules = parseInt(title.split(' capsule')[0] || '0');
    const target_letters = title.split('each')[0]?.split('(')[1] || '';
    
    if (capsules > 0 && target_letters) {
      const price_letters = formatPrice(price / capsules);
      return title.replace(target_letters, price_letters).replace(')', ' ').replace('(', '- ').replace('each', ' each').trim();
    } else {
      return title;
    }
  }

  function getPerCapsulePrice(productId, title) {
    const product = Shopify.collection.products.find((p) => p.id === productId);
    if (!product) {
      return title;
    }

    let cheapestCapsulePrice = null
    for (const variant of product.variants) {
      const capsules = parseInt(variant.title.split(' capsule')[0] || '0');
      const hasEach = title.includes('each');
      if (capsules > 0 && hasEach) {
        const capsulePrice = variant.price * 0.01 / capsules;
        cheapestCapsulePrice = cheapestCapsulePrice ? Math.min(cheapestCapsulePrice, capsulePrice) : capsulePrice;
      }
    }

    if (cheapestCapsulePrice > 0) {
      const price_letters = formatPrice(cheapestCapsulePrice) + ' per capsule';
      const afterEach = (title.split('each')[1] || '').replace(')', '').trim();
      return price_letters + (afterEach ? ' ' + afterEach : '');
    } else {
      return title;
    }
  }
  

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    productVendor: function productVendor() {
      var that2 = this;
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var vendor = urlParams.get('q')

      return that2.vendor === vendor
    },
    productType: function productType() {
      var that = this;
      var currentProduct = Shopify.collection.products.find(function (product) {
        return product.id === that.id;
      });
      if (currentProduct) {
        return currentProduct.type;
      } else if(this.product_type) {
        return this.product_type;
      }
    },
    ctaButton: function ctaButton() {
      var that = this;
      const productHandle = that.handle
      let product = {};

      async function fetchProductUsingHandle(handle) {
        const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then(
          response => response.json()
        )
        .then((data) => {
          const currentVariant = data?.variants.find(variant => variant.id == that.objectID)
          return currentVariant
        })
        .catch(error => {
          console.error('Error:', error);
        });

        product = response;

        const productForm = document.querySelector(`.ais-hit[data-algolia-objectid="${that.objectID}"]`);

        product.available ? productForm.classList.add('product--available') : productForm.classList.add('product--oos');
      }

      fetchProductUsingHandle(productHandle)
    },
    productHidePrice: function productHidePrice() {
      var that = this;
      var currentProduct = Shopify.collection.products.find(function (product) {
        return product.id === that.id;
      });
      if (currentProduct) {
        return currentProduct?.tags?.includes('hide-price');
      }
    },

    metaImage: function metaImage() {
      let products = document.querySelectorAll('.ais-InfiniteHits-item:not(.featured-content)');

      async function fetchImageUsingHandle(handle, image, product) {
        const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        .then(
          response => response.json()
        )
        .then((data) => {
          return data.images[1] ? data.images[1] : 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif'
        })
        .catch(error => {
          console.error('Error:', error);
        });

        image.src = response;
        product.querySelector('.card-wrapper').classList.add('is-hovered')
      }

      async function fetchImage(productQuery, image, product) {
        const url = await fetch(`https://${ window.Shopify.shop }/api/2022-07/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': "24336e2d59a988aee9c3dd961e24868d"
          },
          body: productQuery
        }
        )
        .then(
          response => response.json()
        )
        .then((data) => {
          return data.data.product?.images.edges[1].node.url ? data.data.product.images.edges[1].node.url : 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif'
        })
        .catch(error => {
          console.error('Error:', error);
        });

        image.src = url;
        product.querySelector('.card-wrapper').classList.add('is-hovered')
      }

      products.forEach((product) => {
        product.addEventListener("mouseenter", (event) => {
          let image = product.querySelector('.second-img');
          let handle = product.querySelector('.ais-hit')?.dataset?.handle;

          if(image && image.src.includes('#')) {
            let src = image.dataset.source
            // let productQuery = `{
            //   product(id: "gid://shopify/Product/${id}") {
            //     title
            //     images(first: 2) {
            //       edges {
            //         node {
            //           id
            //           url
            //         }
            //       }
            //     }
            //   }
            // }`
            // fetchImage(productQuery, image, product)
            fetchImageUsingHandle(handle, image, product)

          } else {
            product.querySelector('.card-wrapper').classList.add('is-hovered')
          }
        })
        product.addEventListener("mouseleave", (event) => {
          product.querySelector('.card-wrapper').classList.remove('is-hovered')
        })
      })

      return this;
    },
    firstVariantId: function firstVariantId() {
      var that = this;

      var productVariant = Shopify.collection.products.find(function (product) {
        return product.id === that.id;
      })

      if (productVariant) {
        return productVariant.variants[0].id;
      }
    },
    productForm: function productForm() {
      var that = this;
      var currentProduct = Shopify.collection.products.find(function (product) {
        return product.id === that.id;
      });
      var buttonText = '';
      var buttonHref = '';
      var buttonClass = 'product-card-alt__button';
      var buttonDisabled = false;
      var showPrice = true;
      var disablePriceVendors = "";
      var customer = Shopify.customer[0].customer
      var typeBundle = currentProduct?.tags?.includes('bundle');

      if (disablePriceVendors) {
        if (disablePriceVendors.includes(currentProduct?.vendor)) {
          if (customer === "false") {
            showPrice = false
          }
        }
      }

      if (currentProduct) {
        if (typeBundle) {
          buttonText = 'Learn more';
          buttonHref = '/products/' + currentProduct.handle;
        } else {
          if (!currentProduct.available) {
            buttonText = 'Sold out';
            buttonDisabled = true;
            buttonClass += ' button--outlined';
          } else {
            if (currentProduct.variants.length > 1) {
              buttonText = 'Quick add';
              buttonClass += ' js-show-quickview';
              buttonHref = '/products/' + currentProduct.handle + '?variant=' + currentProduct.variants[0].id;
            } else {
              buttonText = 'Add to cart';
              buttonClass += ' js-add-to-cart';
            }
          }
        }
      }

      if (currentProduct) {
        if (currentProduct.variants.length > 1) {
          return (
            '<a href="' + buttonHref + '"' +
            'class="button ' + buttonClass + '">' +
            '<span>' +
            buttonText +
            '</span>' +
            '</a>'
          );
        }
      }

      if (showPrice) {
        if (typeBundle) {
          return (
            '<a href="' + buttonHref + '"' +
            'class="button ' + buttonClass + '">' +
            '<span>' +
            buttonText +
            '</span>' +
            '</a>'
          );
        } else {
          return (
            '<button ' +
            'type="submit" ' +
            'name="add" ' +
            'data-type="add-to-cart-form" ' +
            'class="button ' + buttonClass + '" ' +
            (buttonDisabled ? 'disabled="disabled"' : '') +
            '>' +
            '<span>' +
            buttonText +
            '</span>' +

            '<div class="loading-overlay__spinner hidden">' +
            '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
            '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
            '</svg>' +
            '</div>' +
            '</button>'
          )
        }
      } else {
        return (
          '<a ' +
          'class="button ' + buttonClass + '" ' +
          'href="/account/login"' +
          '>' +
          '<span>' +
          'Log in to view price' +
          '</span>' +
          '</a>'
        );
      }
    },
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice(text, render) {      
      if ( 
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default' &&
        this.compare_at_price < this.price 
      ) {
        return '<span class="orig-price">' +
          '<span class="visually-hidden">Regular Price</span>' +
          formatPrice(this.price) +
          ' </span>' +
          '<span class="variant-title">' +
            getCustomVariantTitle(this.price, this.variant_title) +
          '</span>';
      } else if (
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default' &&
        this.compare_at_price > this.price
      ) {
        return '<span class="orig-price"><span class="visually-hidden">Sale Price</span>' +
            formatPrice(this.price) +
          '</span>' +
          '<span class="sale-price">' +
          '<span class="visually-hidden">Regular Price</span>' +
            formatPrice(this.compare_at_price) +
          '</span>' +
          '<span class="variant-title">' +
            getCustomVariantTitle(this.price, this.variant_title) +
          '</span>'
        ;
      } else if (
        this.title !== 'Default Title' &&
        this.variant_title !== 'Default' &&
        this.compare_at_price > this.price
      ) {
        return '<span class="orig-price"><span class="visually-hidden">Sale Price</span>' +
         formatPrice(this.price) +
        '</span><span class="sale-price"><span class="visually-hidden">Regular Price</span>' +
          formatPrice(this.compare_at_price) + '</span>'
        ;
      } else {
        return formatPrice(this.price);
      }
    },
    autoProductPrice: function autoProductPrice() {
      if (
        typeof this.variants_min_price !== 'undefined' &&
        typeof this.variants_max_price !== 'undefined'
      ) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        var perCapsulePrice = getPerCapsulePrice(this.id, this.variant_title);
    
        if (min !== max) {
          return '<span class="orig-price">' +
            '<span class="visually-hidden">Regular Price Range</span>' +
            formatPrice(min) + ' - ' + formatPrice(max) +
            '</span>' +
            (perCapsulePrice ? '<span class="variant-title">' + 'From ' + perCapsulePrice + '</span>' : '');
        } else if (
          this.title !== 'Default Title' &&
          this.variant_title !== 'Default' &&
          this.variant_title !== 'Default Title' &&
          this.compare_at_price > this.price
        ) {
          return '<span class="orig-price"><span class="visually-hidden">Sale Price</span>' +
            formatPrice(this.price) +
          '</span>' +
          '<span class="sale-price">' +
          '<span class="visually-hidden">Regular Price</span>' +
            formatPrice(this.compare_at_price) +
          '</span>' +
          '<span class="variant-title">' +
            getCustomVariantTitle(this.price, this.variant_title) +
          '</span>'
        ;
        } else if (
          this.title !== 'Default Title' &&
          this.variant_title !== 'Default' &&
          this.variant_title == 'Default Title' &&
          this.compare_at_price > this.price
        ) {
          return '<span class="orig-price"><span class="visually-hidden">Sale Price</span>' +
            formatPrice(this.price) +
          '</span>' +
          '<span class="sale-price">' +
          '<span class="visually-hidden">Regular Price</span>' +
            formatPrice(this.compare_at_price) +
          '</span>'
        ;
        } else if (
          this.title !== 'Default Title' &&
          this.variant_title !== 'Default' &&
          this.variant_title !== 'Default Title' &&
          this.compare_at_price < this.price
        ) {
          return '<span class="orig-price"><span class="visually-hidden">Sale Price</span>' +
            formatPrice(this.price) +
          '</span>' +
          '<span class="variant-title">' +
            getCustomVariantTitle(this.price, this.variant_title) +
          '</span>'
        ;
        } else {
          return formatPrice(this.price);
        }
      }
    
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio,
        this.variant_title
      );
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPrice(min) + ' - ' + formatPrice(max);
        }
      }

      if (this._distinct) {
        if (!showPrice) {
          return 'Log in to view price';
        }

        if (currentVariant.compare_at_price > currentVariant.price) {
          if (currentProduct.variants) {
            return (
              '<span class="product-card-alt__price__discounted">' +
              formatPrice(currentVariant.price / 100).replace('.00', '') +
              '</span>' +
              '<span class="product-card-alt__price__inner">' +
              formatPrice(currentVariant.compare_at_price / 100).replace('.00', '') +
              '</span>'
            );
          }

          return 'From ' + formatPrice(currentProduct.variants_min_price).replace('.00', '');
        }

        if (currentProduct.variants) {
          if (currentProduct.variants.length > 1 && currentProduct.price_min < currentProduct.price_max) {
            return (
              'From ' + formatPrice(currentProduct.price_min / 100).replace('.00', '')
            );
          }

          return formatPrice(currentProduct.price / 100).replace('.00', '');
        }

        return formatPrice(currentProduct.variants_min_price).replace('.00', '');
        
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    articleSearchLink: function articleSearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/blogs/inspiration/' +
        this.handle
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    getSecondImage: function getSecondImage() {
      let products = document.querySelectorAll('.ais-InfiniteHits-item:not(.featured-content)');
      async function fetchImage(productQuery, image, product) {
        const url = await fetch(`https://${ window.Shopify.shop }/api/2022-07/graphql.json`,
        {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/graphql',
                  'X-Shopify-Storefront-Access-Token': "24336e2d59a988aee9c3dd961e24868d"
              },
              "body": productQuery
          }
        )
        .then(
            response => response.json()
        )
        .then((data) => {
          return data.data.node.image.url
        })
        .catch(error => {
          console.error('Error:', error);
        });

        image.src = url;
        product.querySelector('.card-wrapper').classList.add('is-hovered')
      }

      products.forEach((product) => {
        product.addEventListener("mouseenter", (event) => {
          let image = product.querySelector('.second-img');

          if(image && image.src.includes('#')) {
            let src = image.dataset.source
            let productQuery = `{
              node(id: "${src}") {
                __typename
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }`
            fetchImage(productQuery, image, product)
          } else {
            product.querySelector('.card-wrapper').classList.add('is-hovered')
          }
        })
        product.addEventListener("mouseleave", (event) => {
          product.querySelector('.card-wrapper').classList.remove('is-hovered')
        })
      })
    },

    customSelect: function customSelect(dropdownWrapper, refine, isFirstRender) {
      const toggler = dropdownWrapper.querySelector('.dropdown-toggle');
      const menu = dropdownWrapper.querySelector('.dropdown-menu');

      const toggle = (expand = null) => {
        expand = expand === null
          ? menu.getAttribute('aria-expanded') !== 'true'
          : expand;

        menu.setAttribute('aria-expanded', expand);

        if (expand) {
          toggler.classList.add('active');
          menu.children[0].focus();
          document.addEventListener('click', handleClickOut);
          dropdownWrapper.dispatchEvent(new Event('opened'));
        } else {
          toggler.classList.remove('active');
          dropdownWrapper.dispatchEvent(new Event('closed'));
          document.removeEventListener('click', handleClickOut);
        }
      }
      const handleClickOut = e => {
        if (!this) {
          return document.removeEventListener('click', handleClickOut);
        }
        if (!dropdownWrapper.contains(e.target)) {
          toggle(false);
        }
      };

      const setValue = (item) => {
        let value = item.dataset.value;
        refine(value);
        toggle(false);
        dropdownWrapper.dispatchEvent(new Event('change'));
        toggler.focus();
      }

      const handleItemKeyDown = (e) => {
        e.preventDefault();
        if (e.keyCode === 38 && e.target.previousElementSibling) { // up
          e.target.previousElementSibling.focus();
        } else if (e.keyCode === 40 && e.target.nextElementSibling) { // down
          e.target.nextElementSibling.focus();
        } else if (e.keyCode === 27) { // escape key
          toggle(false);
        } else if (e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
          setValue(e.target);
        }
      }

      const handleToggleKeyPress = (e) => {
        e.preventDefault();
        if (e.keyCode === 9 ) toggler.blur();
        if (e.keyCode === 27) { // escape key
          toggle(false);
        } else if (e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
          toggle(true);
        }
      }

      if(isFirstRender) {
        toggler.addEventListener('keydown', handleToggleKeyPress);
        toggler.addEventListener('click', () => toggle());
      }

      [...menu.children].forEach(item => {
        item.addEventListener('keydown', handleItemKeyDown);
        item.addEventListener('click', (event) => setValue(item));
      });
    }

  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
